<template>
  <b-modal
        scrollable
    id="edit-quantity-order-modal"
    ref="modal"
    header-class="headerModal"
    centered
    size="s"
    :title="`${$t('Edit')}: ${productName}`"
    hide-footer
    @hide="onCancel"
  >
    <div>
      <b-form-group
        :label="$t('Quantity')"
      >
        <b-form-input
          v-model="quantity"
          disabled
        />
      </b-form-group>
      <b-form-group
        :label="$t('NewQuantity')"
      >
        <b-form-input
          v-model.number="newQuantity"
          type="number"
        />
      </b-form-group>
    </div>
    <div class="buttonsEverywhere">
      <b-button
        type="button"
        variant="none"
        class="buttonSubmit"
        @click="onSubmit"
      >
        {{ $t('Submit') }}
      </b-button>
      <b-button
        type="button"
        variant="danger"
        class="buttonCancel"
        @click="onCancel"
      >
        {{ $t('Cancel') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';


export default {
  components: {
  },
  props: ['quantity', 'productName'],
  data() {
    return {
      newQuantity: 0,
    }
  },
  computed: {
    ...mapGetters([]),
  },
  watch: {
    newQuantity(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value > this.quantity || value < 0 || value == '') {
          this.newQuantity = 0
        }
      }, 200);
    },
  },
  mounted() {

  },
  methods: {
    ...mapActions(['addMainDressCategory', 'addInventoryProductSize', 'addColorToMainDressCategoryById']),
    onSubmit() {
      this.$emit('editQuantity', this.newQuantity)
      this.$refs.modal.hide()
      this.onReset()
    },
    onCancel() {
      this.$refs.modal.hide()
      this.onReset()
    },
    onReset() {
      this.newQuantity = 0
    },
  },
}
</script>

  <style lang="scss" scoped>
  .team_table td {
    padding: 16px 9px !important;
  }
  </style>
